import {db } from "../../firebase";

export const updateArray = async({payload,user_id}:{user_id:string, payload:{name:string,value:Array<any>}}) => {
    db.collection("jobseekers").doc(user_id).set({ [payload.name]: payload.value } ,{merge:true})
}
